// extracted by mini-css-extract-plugin
module.exports = {"multiple":"OptionsAnswer_multiple__XPlOy","option":"OptionsAnswer_option___Jk40","row":"OptionsAnswer_row__2gkSx"};